import React from 'react';

// Composant vide pour créer des espaces dans la grille
const EmptyCell: React.FC = () => {
    return <div style={{ width: '100%', height: '100%' }} />;
};

export default EmptyCell;

